<app-base-grid-page
  [posts]="posts"
  [isLoading]="isLoading"
  [itemsCount]="itemsCount"
  [pagesCount]="pagesCount"
  thumbnailType="SONG"
  title="Cântece creștine pentru copii"
  searchPlaceholder="Caută cântece după nume sau etichete"
  (getData)="getData($event)"
></app-base-grid-page>
